import * as React from "react";
import type { SVGProps } from "react";
const SvgSnowboard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16 10a.999.999 0 0 1-.71-.29l-1-1a1.004 1.004 0 1 1 1.42-1.42l1 1A1.001 1.001 0 0 1 16 10ZM8.616 16.926c.122.05.252.075.384.074a.999.999 0 0 0 .71-1.71l-1-1a1.004 1.004 0 1 0-1.42 1.42l1 1a1 1 0 0 0 .326.216Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.31 22.94a4.31 4.31 0 0 1-2.9-7.5l5.29-4.83c1-.93 2-1.9 2.91-2.91l4.83-5.29a4.31 4.31 0 0 1 7.5 3 4.22 4.22 0 0 1-1.4 3.08l-5.3 4.84c-1 .91-2 1.89-2.9 2.9l-4.83 5.3a4.328 4.328 0 0 1-3.09 1.4l-.11.01ZM18.63 3h-.06a2.28 2.28 0 0 0-1.65.75l-4.84 5.3c-.333.333-.667.674-1 1.016-.667.682-1.333 1.364-2 1.984l-5.32 4.86A2.29 2.29 0 0 0 3 18.57a2.32 2.32 0 0 0 .68 1.69 2.22 2.22 0 0 0 1.69.68A2.279 2.279 0 0 0 7 20.19l4.83-5.29c1-1.06 2-2.08 3-3L20.19 7a2.28 2.28 0 0 0 .58-2.552A2.32 2.32 0 0 0 18.63 3Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSnowboard;
